import React, { memo, SVGProps } from 'react';

const IllustrationLineTop = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="60"
			height="132"
			viewBox="0 0 60 132"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<defs>
				<mask id="theMaskTopImage" maskUnits="userSpaceOnUse">
					<path
						id="illustration-line-top"
						d="M1.01872 -153C0.552248 -77.6076 8.49998 67 59 130.5"
						stroke="#FFFFFF"
						strokeWidth="2"
					/>
				</mask>
			</defs>

			<g id="maskReveal" mask="url(#theMaskTopImage)">
				<path
					d="M1.01872 -153C0.552248 -77.6076 8.49998 67 59 130.5"
					stroke="#FF8541"
					strokeWidth="2"
					strokeLinecap="round"
					strokeDasharray="16 16"
				/>
			</g>
		</svg>
	);
};

export default memo(IllustrationLineTop);
